<template>
  <div class="row filter-row">
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus focused">
        <vue-select
          :options="employee_list"
          v-model="searchForm.s_employee_id"
          id="employeeList"
          placeholder="-"
        />
        <label class="focus-label">Employee Name</label>
      </div>
    </div>

    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus focused">
        <vue-select
          :options="designation_list"
          v-model="searchForm.designation_id"
          placeholder="-"
          id="designationList"
        />
        <label class="focus-label">Select Designation</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus focused">
        <vue-select
          :options="department_list"
          v-model="searchForm.department_id"
          placeholder="-"
          id="departmentList"
        />
        <label class="focus-label">Select Department</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-1" style="width: 12.499999995%">
      <a
        href="javascript:;"
        class="btn btn-success w-100 submit-btn mb-3"
        @click="searchEmployee()"
      >
        Search
      </a>
    </div>
    <div class="col-sm-6 col-md-1" style="width: 12.499999995%">
      <a
        href="javascript:;"
        class="btn btn-danger w-100 submit-btn"
        @click="searchEmployee(true)"
      >
        Clear
      </a>
    </div>
  </div>
</template>

<script>
import { notification } from "ant-design-vue";
import axios from "axios";

export default {
  emits: ["reload-data"],
  data() {
    return {
      employeeName: "",
      status: "all",
      employee_list: [],
      designation_list: [],
      department_list: [],
      value: null,
      dept_id: null,
      department: null,
      searchForm: {
        s_employee_id: null,
        designation_id: null,
        department_id: null,
      },
    };
  },
  //   watch: {
  //     employeeID(newVal) {
  //       this.updateData();
  //     },
  //     employeeName(newVal) {
  //       this.updateData();
  //     },
  //     designation_id(newVal) {
  //       this.updateData();
  //     },
  //     status(newVal) {
  //       this.updateData();
  //     },
  //     dept_id(newVal) {
  //       this.updateData();
  //     },
  //   },
  methods: {
    async searchEmployee(isClearFilter = false) {
      if (isClearFilter) {
        this.searchForm = {
          s_employee_id: null,
          designation_id: null,
          department_id: null,
        };
      }
      this.$emit("reload-data", this.searchForm);
    },
    loadAllDesignations() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/designations/all")
        .then((response) => {
          for (let i = 0; i < response.data.data.length; i++) {
            this.designation_list.push({
              id: response.data.data[i].id,
              text: response.data.data[i].name,
            });
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadAllEmployees() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/employees/allemployees")
        .then((response) => {
          for (let i = 0; i < response.data.data.length; i++) {
            this.employee_list.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadAllDepartments() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/departments/all")
        .then((response) => {
          if (response?.data?.data && response?.data?.data?.length) {
            for (let i = 0; i < response?.data?.data.length; i++) {
              this.department_list.push({
                id: response.data.data[i].id,
                text: response.data.data[i].name,
              });
            }
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    // handleChange(value) {
    //   this.$nextTick(() => {
    //     this.designation_id = value;
    //     this.updateData();
    //     this.searchEmployee();
    //   });
    // },
    // handleDeptChange(value) {
    //   this.$nextTick(() => {
    //     this.dept_id = value;

    //     this.updateData();
    //     this.searchEmployee();
    //   });
    // },
  },
  computed: {},
  created() {
    this.loadAllEmployees();
    this.loadAllDesignations();
    this.loadAllDepartments();
  },
};
</script>
